// @module C3.ShoppingExtensions.HomeHeader
define('C3.ShoppingExtensions.HomeHeader.View'
,	[
	    'Profile.Model'
	,   'ProductList.Model'
	,	'underscore'
	,   'Utils'	
	//,   'Backbone.View'
	//,    'SC.Configuration'
    ]
, function (
	   ProfileModel
    ,  ProductListModel  
	,	_
	,  Utils
	//,  BackboneView
	//,  Configuration 
)
{
    'use strict';

    return {

			showSidebar: function showSidebar() {
				jQuery('html').css('background','none');
        		jQuery('#main').addClass('header-sidebar-opened');
        		jQuery('.sidebar-close').show();
        		jQuery('.shopping-layout-header').removeClass('shopping-layout-header-no-hamburger-scroll')
   			 	jQuery('.myaccount-layout-header').removeClass('shopping-layout-header-no-hamburger-scroll')
   			 	jQuery('.checkout-layout-header').removeClass('shopping-layout-header-no-hamburger-scroll')
   			 },

   			getBreadcrumbPages: function() {
		        return { href: '/cart', text: Utils.translate('Shopping Bag') };
		    }, 
   			hideSidebar: function hideSidebar(e) {
		        if (e.target.tagName === 'A') {
		            if (this.activeLink) {
		                this.activeLink.removeClass('active');
		            }
		            this.activeLink = jQuery(e.target);
		            this.activeLink.addClass('active');
		        }
		        jQuery('.sidebar-close').hide();
		        jQuery('#main').removeClass('header-sidebar-opened');
		       jQuery('.shopping-layout-header').addClass('shopping-layout-header-no-hamburger-scroll')
   			 	jQuery('.myaccount-layout-header').addClass('shopping-layout-header-no-hamburger-scroll')
   			 	jQuery('.checkout-layout-header').addClass('shopping-layout-header-no-hamburger-scroll')
        	},
        	setHost:function setHost(e){
        		return true;
        	}/*,
        	renderFacets: function renderFacets()
        	{
        		 this.sliders = this.$('[data-toggle="slider"]').slider();
        		 this.$('[data-collapsed="true"]').hide();
        		 
        		 var exclude_facets = Configuration.ExcludedFacets
        		 ,   exclude_facets_config = exclude_facets.config;

        		 //console.log(exclude_facets_config)

        		 var self = this;

        		 _.each(exclude_facets_config, function(facet) {
			  		//console.log(facet.facetid)
				  	if(self.facetId == facet.facetid){	
				  	//console.log(self.facetId)			
						self.$('.facets-faceted-navigation-item-facet-group').addClass('hide')
					 }
				});

        		
        	}*/

        	, /** Function to divide the input array into multiple array chunks **/
			  geArrChunks(input_Arr, outArrCount){
				var outputArr = [];
				input_Arr     = input_Arr     || [];
				outArrCount   = outArrCount   || 4;
				if(input_Arr.length > 0){
					var elemCount = Math.ceil((input_Arr.length)/outArrCount);
					for(var i=0; i<outArrCount; i++){
						var currentChunkArr = [];
						for(var j=0; j<elemCount; j++){
							var elemIndex = (j*outArrCount)+i;
							if(elemIndex < input_Arr.length){
								currentChunkArr.push(input_Arr[elemIndex]);
							}                
						}
						if(currentChunkArr.length > 0){
							outputArr.push(currentChunkArr);
						}
					}
				}
				return outputArr; 
			}
		};
});
